import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-social-links" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-facebook" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-github" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-linkedin" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-instagram" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]

import { socials } from "@/data";

export default /*#__PURE__*/_defineComponent({
  __name: 'AppSocials',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      _createElementVNode("a", {
        href: _unref(socials).facebook,
        target: "_blank",
        title: "Facebook"
      }, _hoisted_4, 8, _hoisted_2)
    ]),
    _createElementVNode("li", null, [
      _createElementVNode("a", {
        href: _unref(socials).github,
        title: "Github",
        target: "_blank"
      }, _hoisted_7, 8, _hoisted_5)
    ]),
    _createElementVNode("li", null, [
      _createElementVNode("a", {
        href: _unref(socials).linkedin,
        title: "Linkedin",
        target: "_blank"
      }, _hoisted_10, 8, _hoisted_8)
    ]),
    _createElementVNode("li", null, [
      _createElementVNode("a", {
        href: _unref(socials).instagram,
        title: "Instagram",
        target: "_blank"
      }, _hoisted_13, 8, _hoisted_11)
    ])
  ]))
}
}

})